import React, { Component } from 'react';
import Parse                from 'parse';
import Utils                from '../../../Utils/Utility';
import Api                  from '../../../Utils/api';

export default class BankDetailsHolder  extends Component {

    // contextTypes is used to pushed the routes in url
    static contextTypes = {
        router : React.PropTypes.object.isRequired
    }

    constructor(props){
        super(props);

        this.state = {
            customerId          : '',
            paymentMethods      : [],
            initialMessage      : "Loading payment methods ...",
            error               : '',
            enableCardAddScreen : false,
            cardAddActionLabel  : 'Change',
            success             : false
        }

        this.changePaymentMethod    = this.changePaymentMethod.bind(this);
        this.populatePaymentMethods = this.populatePaymentMethods.bind(this);
        this.renderPaymentMethods   = this.renderPaymentMethods.bind(this);
    }

    componentWillMount() {
        if(this.props.activeLocation) {
            let cus_id = this.props.activeLocation["cus_id"];
            this.setState({customerId:cus_id});
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps != null && nextProps.activeLocation) {
            this.setState({
                customerId : nextProps.activeLocation["cus_id"]
            },()=>{
                    this.populatePaymentMethods(null)
            });
        }
    }

    componentDidMount() {

        if( !this.props.activeLocation) {
            return;
        }

        const locId = this.props.activeLocation.objectId;

        let currentUser = Parse.User.current();
        let userId = currentUser.id;
        let sessionToken = currentUser.getSessionToken();

        let self = this;

        if(Utils.isEmpty(this.state.customerId)){

            Api.getLocationDetail(locId, userId, sessionToken)
                .then(
                    (locationDetail) => {
                        this.setState({customerId:locationDetail["cus_id"]});
                        this.populatePaymentMethods(null);
                    },
                    (error) => {
                        console.log("Error occured while fetching latest user data!");
                        Utils.checkErrorIsInvalidSessionToken(error, self.context.router);
                        // this.setState({showSpinner : false });
                    }
                );
        } else {
            this.populatePaymentMethods(null);
        }
    }

    populatePaymentMethods(paymentMethods){

        let self = this;
        if (Utils.isEmpty(this.state.customerId)) {
            this.setState({
                initialMessage      : "Please add a bank account for billing.",
                enableCardAddScreen : true
            });
            return;
        }

        if (paymentMethods == null || paymentMethods.length == 0) {

            let userDetailPtrId = Parse.User.current().id;
            let sessionToken    = Parse.User.current().getSessionToken();

            Api.findCustomerData(userDetailPtrId, sessionToken, self.state.customerId, true)
                .then(
                    function(res){
                        let initialMessage      = "";
                        let enableCardAddScreen = false;
                        let results             = res.data;


                        if(results.length === 0){
                            initialMessage      = "Please add a bank account for billing.";
                            enableCardAddScreen = true;
                        }

                        self.setState({
                            paymentMethods      : results,
                            initialMessage      : initialMessage,
                            enableCardAddScreen : enableCardAddScreen
                        });

                        // console.log("response:"+res);
                    },
                    function(error){
                        console.log(error);
                        Utils.checkErrorIsInvalidSessionToken(error, self.context.router);
                        self.setState({
                            initialMessage      : "Please add a bank account for billing.",
                            enableCardAddScreen : true
                        });
                    }
                );

        } else {
            let initialMessage = "";
            if(paymentMethods.length === 0){
                initialMessage = "You have not saved any cards for transaction.";
            }

            self.setState({
                paymentMethods      : paymentMethods,
                initialMessage      : initialMessage,
                cardAddActionLabel  : 'Change',
                enableCardAddScreen : false,
                success             : true
            });
        }
    }

    changePaymentMethod(e){

        e.preventDefault();
        if(this.state.cardAddActionLabel == 'Change'){
            this.setState({
                enableCardAddScreen : true,
                cardAddActionLabel  : 'Cancel',
                success             : false
            });
        }else if(this.state.cardAddActionLabel == 'Cancel'){
            this.setState({
                enableCardAddScreen : false,
                cardAddActionLabel  : 'Change',
                success             : false
            });
        }
    }

    renderPaymentMethods(){

        let self           = this;
        let paymentMethods = this.state.paymentMethods;

        let component;
        if (paymentMethods.length === 0) {
            /*component = (
                <ul className="list-group">
                    <li className="list-group-item">
                        <b>{this.state.initialMessage}</b>
                    </li>
                </ul>
            );
            */
           component = null;
        } else {
            component = (
                <div className="row">
                    <div className="col-sm-12 col-md-12">
                        <div className="panel panel-primary">
                            <ul className="list-group">
                                {
                                    paymentMethods.map(function(paymentMethod, idx, array) {
                                        return (
                                            <li className="list-group-item" key={'pm'+idx}>
                                                <i className="material-icons">account_balance_wallet</i> <span style={{verticalAlign:'super'}}>{paymentMethod.maskedNumber}</span> <br />
                                                <i className="material-icons">account_balance</i> <span style={{verticalAlign:'super'}}>{paymentMethod.bankName}</span>
                                            </li>
                                            );
                                    })
                                }
                            </ul>
                        </div>
                    </div>
                </div>
            );
        }
        return component;
    }

    render() {

        return (
            <div>
                { this.renderPaymentMethods() }
            </div>
        );
        /*return (
            <div className="row">
                <div className="col-sm-12 col-md-12">
                    <div className="panel panel-primary">
                        {this.renderPaymentMethods()}
                    </div>
                </div>
            </div>
        );
        */
    }
}




// WEBPACK FOOTER //
// src/components/dashboard/billing/bankdetails-holder.js